module.exports = __webpack_public_path__ + "img/Section-3.caa90b94.png";